import { TwinfieldService } from "../../services/twinfield.service";

interface ITwinfieldScope extends ng.IScope {
    redirectTo: string;
    status: boolean;
}

class TwinfieldOAuthCallbackController implements ng.IComponentController {

    /**
     * Constructor
     *
     * @return  {void}
     */

    constructor(
        private TwinfieldService: TwinfieldService,
        public $scope: ITwinfieldScope,
        private localStorageService: ng.local.storage.ILocalStorageService
    ){
        'ngInject';
    }

    /**
     * Initiator
     *
     * @return  {void}
     */

    public $onInit = () => {

        /** Send code to API on oAuth2 callback */

        if( this.getParameter('code') ){

            this.TwinfieldService.setToken( this.getParameter('code') ).then(( status:any ) => {

                this.$scope.status = status == 'true'; console.log( 'token: set ' + this.$scope.status ); this.redirect();

            }).catch(() => { 
            
                this.$scope.status = false; this.redirect(); });

        /** Or redirect to app */

        } else {

            this.redirect();

        }

    }

    /**
     * Get URI parameters
     *
     * @param   {string}  parameter
     * @return  {mixed}             Value or false
     */

    private getParameter = ( parameter: string ) => {

        const url = window.location.href;
        const regex = new RegExp( '^.*[\?\&]{1}' + parameter + '=' );
        const value = url.match( regex ) ? url.replace( regex, '' ).replace( /(\&.+)?$/, '' ) : false;

    return value; }

    /**
     * Redirect after Twinfield token
     *
     * @return  {void}
     */

    private redirect = () => {

        /** Set twinfield URI nonces */

        let defaultUri: string = '/app';
        let redirectTo: string = this.localStorageService.get( 'twinfieldRedirect' ) || defaultUri;

        /** Log */

        console.log( 'redirectTo: ' + redirectTo );

        /** Redirect */

        if( parent.location.pathname !== redirectTo.replace( /\/*\?+.*$/, '' ) ){

            /** Reset to prevent loop */
        
            this.localStorageService.set( 'twinfieldRedirect', defaultUri ); 

            /** Redirect */
            
            parent.location.href = redirectTo; } }

}

export const twinfieldOAuthCallbackComponent: ng.IComponentOptions = {

    controller: TwinfieldOAuthCallbackController,
    template: <string>require('./twinfield.html')

};


// WEBPACK FOOTER //
// ./src/app/modules/twinfield/twinfield.component.ts